// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"Confirmation_loading-container__18SN7","container":"Confirmation_container__3BWla"};